import { render, staticRenderFns } from "./TabSelectorComponent.vue?vue&type=template&id=5aa7bfb5&scoped=true&lang=pug"
import script from "./TabSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./TabSelectorComponent.vue?vue&type=script&lang=ts"
import style0 from "./TabSelectorComponent.vue?vue&type=style&index=0&id=5aa7bfb5&lang=scss&scoped=true"
import style1 from "./TabSelectorComponent.vue?vue&type=style&index=1&id=5aa7bfb5&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7bfb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa7bfb5')) {
      api.createRecord('5aa7bfb5', component.options)
    } else {
      api.reload('5aa7bfb5', component.options)
    }
    module.hot.accept("./TabSelectorComponent.vue?vue&type=template&id=5aa7bfb5&scoped=true&lang=pug", function () {
      api.rerender('5aa7bfb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabs/TabSelector/TabSelectorComponent.vue"
export default component.exports